export default __webpack_public_path__ + "static/media/roboto-v27-latin-100.9391e6e2.woff";